import { Draft } from '@reduxjs/toolkit';
/* Keys to be preserved in the store globally (regardless of slice) after logout reset */
export const GLOBAL_PRESERVE_KEYS: string[] = [];

// Helper function to preserve specified keys
export const preserveStateKeys = <State>(
  state: State | Draft<State>,
  keysToPreserve: string[],
): Record<string, any> =>
  Object.fromEntries(
    keysToPreserve.map((key) => [key as string, (state as Record<string, any>)[key] ?? null]),
  );

// Helper function to reset the state, considering preservation of certain keys
export const resetStore = <State>(
  state: State | Draft<State>,
  initialState: State | (() => State),
  preservedState: Record<string, any>,
  keysToPreserve: string[],
): State => {
  // This may also be a "lazy initializer" function, which should return an initial state value when called.
  // and functional is primarily useful for cases like reading initial state from localStorage to avoid Stale state
  const resolvedInitialState =
    typeof initialState === 'function'
      ? (initialState as () => State)() // Call the function to get dynamic state
      : initialState; // Use the object directly

  const reset: Partial<State> = {};
  Object.keys(state as Record<string, any>).reduce((acc, key) => {
    acc[key as keyof State] = keysToPreserve.includes(key)
      ? preservedState[key]
      : resolvedInitialState[key as keyof State];
    return acc;
  }, reset);

  return reset as State;
};
